import { Pipe, PipeTransform } from "@angular/core";

import { ImageConfig, Scene7ImageUrlBuilder } from "./scene7-image-url.helper";

/**
 * @deprecated Use `<h-image>` component from @hermes/aphrodite/image
 */
@Pipe({
    name: "hImageUrl",
    pure: false,
})
export class ImageUrlPipe implements PipeTransform {
    public transform(
        url: string,
        value: ImageConfig,
        applyBackground = false,
        applyTransparency = false,
    ): string {
        return new Scene7ImageUrlBuilder(url, value).build(
            applyBackground,
            applyTransparency,
        );
    }
}
